import { HttpStatusCode } from 'axios';
import { useMemo } from 'react';
import { useAuthState } from 'state';
import { PaymentDetail, PaymentSummary } from 'types';
import ApiService from './ApiService';

export class PaymentService extends ApiService {
    
    async getPaymentDocuments(accountId: string, vendorId: string, paymentIdRef: string, paymentDetail: PaymentDetail) {
        const { data, status } = await this.get(`/api/accounts/${accountId}/vendors/${vendorId}/payments/${paymentIdRef}/documents`
            + this.getOptionalQueryParam(true, 'AdjustmentTypeId', paymentDetail.adjustmentTypeId?.toString())
            + this.getOptionalQueryParam(false, 'AdjustmentAmount', paymentDetail.adjustmentAmount?.toString() ?? "0")
            + this.getOptionalQueryParam(false, 'InvoiceId', paymentDetail.invoiceId)
            + this.getOptionalQueryParam(false, 'MockInvoice', paymentDetail.mockInvoice)
            + this.getOptionalQueryParam(false, 'CustomerId', paymentDetail.customerId)
            + this.getOptionalQueryParam(false, 'CustomerItemReference', paymentDetail.customerItemReference)
            + this.getOptionalQueryParam(false, 'VoucherId', paymentDetail.voucherId)
            + this.getOptionalQueryParam(false, 'AdjustmentIdentityKey', paymentDetail.adjustmentIdentityKey)
            + this.getOptionalQueryParam(false, 'SupplierId', paymentDetail.onBaseSupplierId)
            + this.getOptionalQueryParam(false, 'VoucherPoId', paymentDetail.voucherPoId)
            + this.getOptionalQueryParam(false, 'MarPoReference', paymentDetail.marPoReference)
            + this.getOptionalQueryParam(false, 'MarBillingCodeId', paymentDetail.marBillingCodeId?.toString())
            + this.getOptionalQueryParam(false, 'MarBillCodeDescription', paymentDetail.marBillCodeDescription)
            + this.getOptionalQueryParam(false, 'DeductAmt', paymentDetail.adjustmentAmount.toString()));
        return status === HttpStatusCode.Ok ? data : [];
    }

    async getPaymentDetailByInvoiceId(accountId: string, vendorId: string, paymentId?: string, invoiceId?: string): Promise<PaymentDetail[]> {
        const { data } =
            await this.get(`api/accounts/${accountId}/vendors/${vendorId}/payments/${paymentId}`
                + this.getOptionalQueryParam(true, 'InvoiceId', invoiceId));
        return data;
    }

    async getPaymentDetails(accountId: string, vendorId: string, paymentId: string): Promise<PaymentDetail[]> {
        const { data, status } = await this.get(`/api/accounts/${accountId}/vendors/${vendorId}/payments/${paymentId}`);
        return this.IsSuccessStatusCode(status) ? data : [];
    }

    async getPaymentSummaries(accountId: string, durationInDays: string): Promise<PaymentSummary[]> {
        const { data, status } = await this.get(
            `/api/payment-summaries?accountId=${accountId}&RetrieveDays=-${durationInDays}`
        );
        return this.IsSuccessStatusCode(status) ? data : [];
    }
}

export const usePaymentService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new PaymentService(), [auth]);
};
